module.exports = __webpack_public_path__ + "fonts/Inter-900-latin66.5eb4a77.woff2";